<template>
  <div class="account-page">
    <NavbarSecondaryAccount />
    <div class="top-line--flex">
      <h1>Account Info</h1>
    </div>

    <div v-if="tokenPayload" class="paper-block-container mt-2">
      <Account />
    </div>

    <div
      v-else
      class="paper-block-container paper-block-container--logged-out"
      style="margin-top: 8px"
    >
      You are logged out
    </div>
  </div>
</template>

<script>
  import PageTitle from '@/mixins/page-title';
  import { AuthService } from '@/services/auth.service';
  import NavbarSecondaryAccount from '@/components/blocks/layouts/NavbarSecondaryAccount';
  import VersionHelper from 'utils/VersionHelper';
  import Account from '@/components/blocks/reactComponents/Account.vue';

  const currentVersion = VersionHelper.clientVersion?.split('-')?.[0] ?? 'Unknown';

  export default {
    name: 'AccountPage',

    components: {
      Account,
      NavbarSecondaryAccount,
    },

    mixins: [PageTitle],

    data() {
      return {
        pageTitle: 'HPLC Cloud: Account',
        tokenPayload: AuthService.userData(),
        currentVersion,
      };
    },
  };
</script>
